<div class="treeContainer">
  <nav class="breadcrumb navigation-bar" [title]="getBreadcrumb()">
    <span (click)="openBreadcrumbGroup()" class="folder" *ngIf="knowledgeBaseSearchRequest != null || breadcrumb.length !== 0">
      <span class="cng-ico_home" aria-hidden="true"></span>
      <span class="nodisplay">{{ 'agent:panel.knowledge_base.home' | translate }}</span>
    </span>
    <span *ngIf="knowledgeBaseSearchRequest == null && breadcrumb.length === 0">
      <span class="cng-ico_home" aria-hidden="true"></span>
      <span class="nodisplay">{{ 'agent:panel.knowledge_base.home' | translate }}</span>
    </span>
    <span
      (click)="openBreadcrumbGroup(breadcrumb[breadcrumb.length - 2])"
      class="folder"
      *ngIf="breadcrumb.length > 1 && currentDocument == null"
    >
      {{ '/ ...' }}
    </span>
    <span (click)="openBreadcrumbGroup(breadcrumb[breadcrumb.length - 1])" class="folder" *ngIf="currentDocument != null">
      {{ '/ ... ' }}
    </span>
    <span *ngIf="currentDocument != null">
      {{ '/ ' + currentDocument.label }}
    </span>
    <span *ngIf="breadcrumb.length && currentDocument == null">
      {{ ' / ' + breadcrumb[breadcrumb.length - 1].libelle }}
    </span>
  </nav>
  <nav *ngIf="breadcrumb.length" class="backButton" title="{{ 'commons:actions.back' | translate | uppercase }}">
    <div *ngIf="currentDocument == null" (click)="openBreadcrumbGroup(breadcrumb[breadcrumb.length - 2])">
      <mat-icon fontSet="mat">arrow_left</mat-icon>&nbsp;
      {{ 'commons:actions.back' | translate | uppercase }}
    </div>
    <div *ngIf="currentDocument != null" (click)="openBreadcrumbGroup(breadcrumb[breadcrumb.length - 1])">
      <mat-icon fontSet="mat">arrow_left</mat-icon>&nbsp;
      {{ 'commons:actions.back' | translate | uppercase }}
    </div>
  </nav>
  <div class="flex-column knowledgeBaseTree" *ngIf="!this.currentDocument">
    <div>
      <h2 *ngIf="knowledgeBaseGroups.length > 0">{{ 'agent:panel.knowledge_base.subgroups' | translate }}</h2>
      <ul *ngIf="knowledgeBaseGroups.length > 0">
        <li *ngFor="let kbItem of knowledgeBaseGroups">
          <span (click)="openGroup(kbItem)" class="cng-ico_page_next folder">
            {{ kbItem.libelle }}
          </span>
        </li>
      </ul>
      <h2
        [className]="knowledgeBaseGroups.length && knowledgeBaseDocuments.length ? 'groupsDocumentsSeparator' : ''"
        *ngIf="knowledgeBaseDocuments.length > 0 || (!knowledgeBaseGroups.length && !knowledgeBaseDocuments.length)"
      >
        {{ 'agent:panel.knowledge_base.documents' | translate }}
      </h2>
      <ul *ngIf="knowledgeBaseDocuments.length > 0">
        <li *ngFor="let kbItem of knowledgeBaseDocuments">
          <span (click)="openDocument(kbItem.num)" class="cng-ico_doc document">
            {{ kbItem.libelle }}
          </span>
        </li>
      </ul>
      <div *ngIf="!knowledgeBaseGroups.length && !knowledgeBaseDocuments.length" class="noResult">
        {{ 'agent:panel.knowledge_base.no_result' | translate }}
      </div>
    </div>
  </div>
  <div class="knowledgeBaseDocument flex-column" *ngIf="currentDocument != null">
    <div class="contentContainer">
      <span class="titleDocument">
        <h2>{{ currentDocument.label }}</h2>
        <knowledge-base-attachment
          *ngIf="currentDocument.linkType !== LinkTypeEnumeration.NO_LINK || currentDocument.attachments.length"
          [currentDocument]="currentDocument"
          [ngClass]="'attachmentContainer'"
        ></knowledge-base-attachment>
      </span>
      <hr aria-hidden="true" class="flex-hr" />
      <div class="documentContent" [innerHtml]="currentDocument.content"></div>
    </div>
    <cng-action-buttonbar (actionClickFn)="documentActionClickFn($event)" class="actionButtons">
      <cng-action-btn
        [action]="ActionType.INSERT"
        color="primary"
        type="submit"
        [title]="'agent:contact.mailactions.insertKnowlegdeDialog' | translate"
        [disabled]="!canCopyPaste"
      >
        <mat-icon>insert_text</mat-icon>
        {{ 'agent:contact.mailactions.insertKnowlegdeDialog' | translate | capitalize }}
      </cng-action-btn>
    </cng-action-buttonbar>
  </div>
  <div class="cng-loader" *ngIf="loading"><div class="loader"></div></div>
</div>
